import React from 'react';
import Icon from '../../../components/AppIcon';

const KeyDatesSection = () => {
  const keyDates = [
    { 
      label: 'Contract Effective Date', 
      date: 'January 1, 2025', 
      status: 'completed', 
      icon: 'Calendar',
      description: 'Contract officially becomes active'
    },
    { 
      label: 'First Payment Due', 
      date: 'January 31, 2025', 
      status: 'upcoming', 
      icon: 'DollarSign',
      description: 'Initial payment milestone'
    },
    { 
      label: 'Quarterly Review', 
      date: 'March 31, 2025', 
      status: 'upcoming', 
      icon: 'Clock',
      description: 'Performance and compliance review'
    },
    { 
      label: 'Mid-term Assessment', 
      date: 'December 31, 2025', 
      status: 'future', 
      icon: 'BarChart',
      description: 'Comprehensive contract evaluation'
    },
    { 
      label: 'Renewal Notice Due', 
      date: 'September 30, 2026', 
      status: 'future', 
      icon: 'Bell',
      description: 'Deadline for renewal decision notification'
    },
    { 
      label: 'Contract Expiration', 
      date: 'December 31, 2026', 
      status: 'future', 
      icon: 'AlertTriangle',
      description: 'End of current contract term'
    }
  ];

  const milestones = [
    {
      phase: 'Phase 1 - Implementation',
      startDate: 'Jan 1, 2025',
      endDate: 'Jun 30, 2025',
      progress: 15,
      status: 'active'
    },
    {
      phase: 'Phase 2 - Optimization',
      startDate: 'Jul 1, 2025',
      endDate: 'Dec 31, 2025',
      progress: 0,
      status: 'pending'
    },
    {
      phase: 'Phase 3 - Maintenance',
      startDate: 'Jan 1, 2026',
      endDate: 'Dec 31, 2026',
      progress: 0,
      status: 'pending'
    }
  ];

  const getStatusConfig = (status) => {
    switch (status) {
      case 'completed':
        return { color: 'text-success', bg: 'bg-success/10', label: 'Completed' };
      case 'upcoming':
        return { color: 'text-warning', bg: 'bg-warning/10', label: 'Upcoming' };
      case 'active':
        return { color: 'text-primary', bg: 'bg-primary/10', label: 'Active' };
      case 'pending':
        return { color: 'text-muted-foreground', bg: 'bg-muted/50', label: 'Pending' };
      default:
        return { color: 'text-muted-foreground', bg: 'bg-muted/50', label: 'Future' };
    }
  };

  return (
    <div className="space-y-6">
      <div className="bg-card rounded-lg border border-border p-6 shadow-sm">
        <div className="flex items-center space-x-2 mb-6">
          <Icon name="Calendar" size={20} className="text-primary" />
          <h2 className="text-xl font-semibold text-foreground">Important Dates</h2>
        </div>
        
        <div className="space-y-4">
          {keyDates?.map((item, index) => {
            const statusConfig = getStatusConfig(item?.status);
            
            return (
              <div key={index} className="flex items-center justify-between p-4 bg-muted/30 rounded-lg">
                <div className="flex items-center space-x-4">
                  <div className={`p-2 rounded-lg ${statusConfig?.bg}`}>
                    <Icon name={item?.icon} size={18} className={statusConfig?.color} />
                  </div>
                  <div>
                    <p className="text-base font-medium text-foreground mb-1">
                      {item?.label}
                    </p>
                    <p className="text-sm text-muted-foreground">
                      {item?.description}
                    </p>
                    <p className="text-sm text-foreground font-mono mt-1">
                      {item?.date}
                    </p>
                  </div>
                </div>
                <div className={`px-3 py-1 rounded-full text-xs font-medium ${statusConfig?.color} ${statusConfig?.bg}`}>
                  {statusConfig?.label}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="bg-card rounded-lg border border-border p-6 shadow-sm">
        <div className="flex items-center space-x-2 mb-6">
          <Icon name="BarChart" size={20} className="text-primary" />
          <h3 className="text-lg font-semibold text-foreground">Project Milestones</h3>
        </div>
        
        <div className="space-y-6">
          {milestones?.map((milestone, index) => {
            const statusConfig = getStatusConfig(milestone?.status);
            
            return (
              <div key={index} className="border border-border rounded-lg p-4">
                <div className="flex items-center justify-between mb-3">
                  <h4 className="text-base font-medium text-foreground">
                    {milestone?.phase}
                  </h4>
                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${statusConfig?.color} ${statusConfig?.bg}`}>
                    {statusConfig?.label}
                  </span>
                </div>
                <div className="flex items-center justify-between text-sm text-muted-foreground mb-3">
                  <span className="font-mono">{milestone?.startDate}</span>
                  <span>to</span>
                  <span className="font-mono">{milestone?.endDate}</span>
                </div>
                <div className="space-y-2">
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-muted-foreground">Progress</span>
                    <span className="text-foreground font-medium">{milestone?.progress}%</span>
                  </div>
                  <div className="w-full bg-muted rounded-full h-2">
                    <div 
                      className="bg-primary h-2 rounded-full transition-all duration-300"
                      style={{ width: `${milestone?.progress}%` }}
                    ></div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default KeyDatesSection;